var map = {
	"./": [
		95762,
		5762
	],
	"./bsc": [
		43962,
		3962
	],
	"./bsc.ts": [
		43962,
		3962
	],
	"./bscTestnet": [
		80491,
		491
	],
	"./bscTestnet.ts": [
		80491,
		491
	],
	"./goerli": [
		75023,
		5023
	],
	"./goerli.ts": [
		75023,
		5023
	],
	"./index": [
		95762,
		5762
	],
	"./index.ts": [
		95762,
		5762
	],
	"./polygonZkEVM": [
		79334,
		9334
	],
	"./polygonZkEVM.ts": [
		79334,
		9334
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 24615;
module.exports = webpackAsyncContext;